import React from 'react';
import { getUrls } from '../../config';
import { WebViewFaqWithBack } from './WebViewFaqWithBack';

export const HeartRateFaq = (props:{ closeModal:()=>void }) => {
    const { HEART_RATE_FAQ } = getUrls();
    return (
        <WebViewFaqWithBack url={HEART_RATE_FAQ} backFromFirstPageEvent={props.closeModal}  />
    );
};
